export default "__VITE_ASSET__DX9nzSP7__"